import { message } from "antd";
import InternalApi from "../axios/internalApi";

// Community-posted deals from yupup.com — moderation endpoints (ADMIN role).

export const getPublicDealsQueue = async ({ status = "pending", page = 1, pageSize = 20 } = {}) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `public-deals/moderation?status=${status}&page=${page}&pageSize=${pageSize}`,
    });
  } catch (error) {
    message.error(error?.data?.message || "Failed to load deals");
  }
};

export const approvePublicDeal = async (id) => {
  try {
    return await InternalApi.patch({
      server: "api/v1/",
      path: `public-deals/${id}/approve`,
    });
  } catch (error) {
    message.error(error?.data?.message || "Failed to approve deal");
  }
};

export const rejectPublicDeal = async (id, reason) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `public-deals/${id}/reject`,
      },
      { reason: reason || "" }
    );
  } catch (error) {
    message.error(error?.data?.message || "Failed to reject deal");
  }
};

export const removePublicDeal = async (id) => {
  try {
    return await InternalApi.patch({
      server: "api/v1/",
      path: `public-deals/${id}/remove`,
    });
  } catch (error) {
    message.error(error?.data?.message || "Failed to remove deal");
  }
};
